import { render } from "./UserRecharge.vue?vue&type=template&id=d428a4a2&scoped=true"
import script from "./UserRecharge.vue?vue&type=script&lang=js"
export * from "./UserRecharge.vue?vue&type=script&lang=js"

import "./UserRecharge.vue?vue&type=style&index=0&id=d428a4a2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d428a4a2"]])

export default __exports__